// 포커스음원 특화 유틸리티 함수

// 공통 함수들 import
export * from './musicCommon.js';

// 포커스음원 카테고리별 테두리 색상 (포커스음원 특화)
export const CATEGORY_BORDER_COLORS = {
	1: "border-primary",
	2: "border-success", 
	3: "border-info",
	4: "border-warning",
	5: "border-danger",
	6: "border-secondary",
	7: "border-dark",
	8: "border-light"
};

// 포커스음원 카테고리 테두리 색상 함수 (포커스음원 특화)
export function getCategoryBorderColor(categoryId) {
	return CATEGORY_BORDER_COLORS[categoryId] || "border-secondary";
} 